import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const API = `${API_BASE_URL}/api`;

const WEEKDAY_NAMES = ['Mánudagur', 'Þriðjudagur', 'Miðvikudagur', 'Fimmtudagur', 'Föstudagur', 'Laugardagur', 'Sunnudagur'];

export default function RebookPage() {
  const token = window.location.pathname.split('/rebook/')[1];
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}/public/rebook/${token}`);
        setData(res.data);
      } catch (err) {
        const msg = err.response?.data?.detail || 'Villa við að sækja endurbókunarupplýsingar';
        setError(msg);
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchData();
    else { setError('Ógildur linkur'); setLoading(false); }
  }, [token]);

  const handleConfirm = async () => {
    if (!selectedDate || !selectedTime) return;
    setConfirming(true);
    try {
      await axios.post(`${API}/public/rebook/${token}`, {
        date: selectedDate,
        time: selectedTime
      });
      setSuccess(true);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Villa við endurbókun';
      setError(msg);
    } finally {
      setConfirming(false);
    }
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr + 'T12:00:00');
    const day = d.getDate();
    const months = ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember'];
    return `${day}. ${months[d.getMonth()]}`;
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 40, height: 40, border: '4px solid #e5e7eb', borderTopColor: '#1e40af', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
          <p style={{ color: '#64748b' }}>Hleð...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
        <div style={{ maxWidth: 420, padding: 32, background: 'white', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, background: '#fef2f2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 24 }}>!</div>
          <h2 style={{ margin: '0 0 8px', color: '#1e293b', fontSize: 20 }}>Villa</h2>
          <p style={{ color: '#64748b', margin: 0 }}>{error}</p>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
        <div style={{ maxWidth: 420, padding: 32, background: 'white', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, background: '#f0fdf4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28, color: '#16a34a' }}>&#10003;</div>
          <h2 style={{ margin: '0 0 8px', color: '#1e293b', fontSize: 22 }}>Bókun staðfest!</h2>
          <p style={{ color: '#64748b', margin: '0 0 16px' }}>
            Nýr tími: <strong>{formatDate(selectedDate)}</strong> kl. <strong>{selectedTime}</strong>
          </p>
          <p style={{ color: '#64748b', fontSize: 14 }}>Við munum hafa samband til að staðfesta bókunina.</p>
        </div>
      </div>
    );
  }

  const selectedDateObj = data?.available_dates?.find(d => d.date === selectedDate);

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      {/* Header */}
      <div style={{ background: '#1e40af', padding: '20px 0', textAlign: 'center' }}>
        <img src="/alvorubon-top.png" alt="Alvörubón" style={{ maxWidth: 180, height: 'auto' }} onError={(e) => { e.target.style.display = 'none'; }} />
      </div>

      <div style={{ maxWidth: 520, margin: '0 auto', padding: '24px 16px' }}>
        {/* Info box */}
        <div style={{ background: 'white', borderRadius: 12, padding: 24, marginBottom: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
          <h1 style={{ fontSize: 22, margin: '0 0 4px', color: '#1e293b' }}>Velja nýjan tíma</h1>
          <p style={{ color: '#64748b', margin: '0 0 16px', fontSize: 14 }}>Bíll: <strong>{data.plate}</strong> &bull; {data.customer_name}</p>

          {data.services && data.services.length > 0 && (
            <div style={{ background: '#f0f9ff', borderRadius: 8, padding: '10px 14px', marginBottom: 12 }}>
              <span style={{ fontSize: 13, color: '#0369a1', fontWeight: 600 }}>Þjónusta: </span>
              <span style={{ fontSize: 13, color: '#0c4a6e' }}>{data.services.map(s => s.service || s.name).join(', ')}</span>
            </div>
          )}

          {data.rejection_reason && (
            <div style={{ background: '#fef2f2', borderLeft: '3px solid #dc2626', borderRadius: '0 8px 8px 0', padding: '10px 14px' }}>
              <span style={{ fontSize: 13, color: '#991b1b', fontWeight: 600 }}>Ástæða höfnunar: </span>
              <span style={{ fontSize: 13, color: '#7f1d1d' }}>{data.rejection_reason}</span>
            </div>
          )}
        </div>

        {/* Date selection */}
        <div style={{ background: 'white', borderRadius: 12, padding: 24, marginBottom: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
          <h2 style={{ fontSize: 16, margin: '0 0 14px', color: '#1e293b' }}>Veldu dagsetningu</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 8 }}>
            {data.available_dates?.map(d => (
              <button
                key={d.date}
                data-testid={`date-${d.date}`}
                onClick={() => { setSelectedDate(d.date); setSelectedTime(null); setTimeout(() => { const el = document.getElementById('time-section'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100); }}
                style={{
                  padding: '10px 8px',
                  border: selectedDate === d.date ? '2px solid #1e40af' : '1px solid #e5e7eb',
                  borderRadius: 8,
                  background: selectedDate === d.date ? '#eff6ff' : 'white',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.15s'
                }}
              >
                <div style={{ fontSize: 13, fontWeight: 600, color: selectedDate === d.date ? '#1e40af' : '#1e293b' }}>
                  {formatDate(d.date)}
                </div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                  {WEEKDAY_NAMES[d.weekday]}
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Time selection */}
        {selectedDate && selectedDateObj && (
          <div id="time-section" style={{ background: 'white', borderRadius: 12, padding: 24, marginBottom: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
            <h2 style={{ fontSize: 16, margin: '0 0 14px', color: '#1e293b' }}>
              Veldu tíma - {formatDate(selectedDate)}
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: 8 }}>
              {selectedDateObj.slots.map(slot => (
                <button
                  key={slot}
                  data-testid={`time-${slot}`}
                  onClick={() => setSelectedTime(slot)}
                  style={{
                    padding: '10px 6px',
                    border: selectedTime === slot ? '2px solid #1e40af' : '1px solid #e5e7eb',
                    borderRadius: 8,
                    background: selectedTime === slot ? '#1e40af' : 'white',
                    color: selectedTime === slot ? 'white' : '#1e293b',
                    cursor: 'pointer',
                    fontSize: 14,
                    fontWeight: 500,
                    transition: 'all 0.15s'
                  }}
                >
                  {slot}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Confirm button */}
        {selectedDate && selectedTime && (
          <button
            data-testid="confirm-rebook-btn"
            onClick={handleConfirm}
            disabled={confirming}
            style={{
              width: '100%',
              padding: '16px',
              background: confirming ? '#93c5fd' : '#1e40af',
              color: 'white',
              border: 'none',
              borderRadius: 12,
              fontSize: 16,
              fontWeight: 600,
              cursor: confirming ? 'not-allowed' : 'pointer',
              boxShadow: '0 4px 12px rgba(30, 64, 175, 0.3)',
              transition: 'all 0.2s'
            }}
          >
            {confirming ? 'Bóka...' : `Staðfesta: ${formatDate(selectedDate)} kl. ${selectedTime}`}
          </button>
        )}
      </div>
    </div>
  );
}
